var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartStroke = function SvgHeartStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    "data-name": "Rectangle 24526"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#072c54",
    d: "m12.005 18.759.341-.308c4.7-4.271 7.8-7.092 7.8-10.056a3.7 3.7 0 0 0-3.732-3.735 4.2 4.2 0 0 0-3.15 1.466L12 7.61l-1.263-1.484A4.2 4.2 0 0 0 7.591 4.66a3.7 3.7 0 0 0-3.74 3.74c0 2.969 3.115 5.794 7.83 10.069l.324.295m0 2.241-1.422-1.295C5.526 15.124 2.191 12.1 2.191 8.4a5.343 5.343 0 0 1 5.4-5.4 5.87 5.87 0 0 1 4.414 2.05A5.87 5.87 0 0 1 16.414 3a5.343 5.343 0 0 1 5.4 5.4c0 3.708-3.335 6.729-8.387 11.32Z",
    "data-name": "Path 5902"
  })));
};
export { SvgHeartStroke as ReactComponent };
export default "/_next/static/images/heart-stroke.svg";